import { motion } from "framer-motion";
import { Home, Layers } from "lucide-react";

interface FloorPlanProps {
  floorPlan: {
    levels: { name: string; rooms: string[] }[];
  };
}

export const FloorPlan = ({ floorPlan }: FloorPlanProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      className="space-y-8"
    >
      <div className="flex items-center gap-3 mb-6">
        <Layers className="text-gold" size={24} />
        <h3 className="font-display text-2xl lg:text-3xl text-foreground">Floor Plans</h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {floorPlan.levels.map((level, index) => (
          <motion.div
            key={level.name}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: index * 0.1 }}
            className="bg-secondary/30 border border-border/30 p-6 hover:border-gold/30 transition-colors duration-300"
          >
            <div className="flex items-center gap-3 mb-4 pb-4 border-b border-border/30">
              <div className="w-10 h-10 bg-gold/10 flex items-center justify-center">
                <Home className="text-gold" size={18} />
              </div>
              <h4 className="font-display text-xl text-foreground">{level.name}</h4>
            </div>
            <ul className="space-y-2">
              {level.rooms.map((room) => (
                <li
                  key={room}
                  className="font-body text-muted-foreground text-sm flex items-center gap-2"
                >
                  <span className="w-1.5 h-1.5 bg-gold/60 rounded-full" />
                  {room}
                </li>
              ))}
            </ul>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};
